// extracted by mini-css-extract-plugin
export default {"contest_nag":"styles_contest_nag__Vwhyo","nag_container_top":"styles_nag_container_top__LTDl2","nag_container":"styles_nag_container__IE2nz"};